import { makeStyles } from '@material-ui/styles';

export default makeStyles(theme => ({
  container: {
    width: '100%',
    height: '100%',
    backgroundColor: theme.palette.colors.white,
    overflow: 'auto',
  },
  content: {
    height: '100%',
    margin: [0, theme.spacing(4)],
    padding: [theme.spacing(4), 0, 0],
    [theme.breakpoints.up('mobile')]: {
      minWidth: 700,
      width: '100%',
      maxWidth: 1420,
      margin: [0, 'auto'],
      padding: [theme.spacing(7), 20, theme.spacing(13)],
    },
  },
  header: {
    marginBottom: theme.spacing(3),
    [theme.breakpoints.up('mobile')]: {
      marginBottom: theme.spacing(8),
    },
  },
  staffList: {
    padding: [0, 0, theme.spacing(2)],
    borderBottom: [1, 'solid', theme.palette.colors.border],
    [theme.breakpoints.up('mobile')]: {
      display: 'flex',
      borderBottom: 'none',
      padding: 0,
      marginBottom: theme.spacing(8),
    },
  },
  staffItem: {
    padding: [theme.spacing(2), 12],
    border: [1, 'solid', theme.palette.colors.border],
    borderRadius: 8,
    marginBottom: theme.spacing(2),
    [theme.breakpoints.up('mobile')]: {
      flexDirection: 'column',
      padding: 0,
      marginBottom: 0,
      alignItems: 'flex-start',
      border: 'none',
      marginRight: theme.spacing(2),
    },
  },
  avatar: {
    width: 64,
    height: 64,
    borderRadius: 10,
    [theme.breakpoints.up('mobile')]: {
      width: 96,
      height: 96,
      borderRadius: 16,
    },
  },
  text: {
    margin: 0,
    marginLeft: theme.spacing(3),
    [theme.breakpoints.up('mobile')]: {
      margin: 0,
      marginTop: theme.spacing(3),
    },
  },
  name: {
    fontWeight: 700,
    marginBottom: 4,
    fontSize: 16,
    lineHeight: '16px',
    [theme.breakpoints.up('mobile')]: {
      marginBottom: theme.spacing(1),
    },
  },
  position: {
    fontSize: 12,
    marginBottom: theme.spacing(1),
    [theme.breakpoints.up('mobile')]: {
      marginBottom: theme.spacing(2),
      fontSize: 16,
    },
  },
  socialButton: {
    padding: 0,
  },
  description: {
    paddingTop: theme.spacing(4),
    [theme.breakpoints.up('mobile')]: {
      padding: 0,
      display: 'flex',
      alignItems: 'flex-start',
    },
  },
  videoBlock: {
    display: 'flex',
    alignItems: 'center',
    marginBottom: theme.spacing(3),
  },
  video: {
    border: 'none',
    borderRadius: theme.spacing(1),
    width: 114,
    height: 64,
    marginRight: 20,
    [theme.breakpoints.up('mobile')]: {
      width: 573,
      height: 322,
      marginRight: 0,
    },
  },
  descriptionList: {
    padding: 0,
    [theme.breakpoints.up('mobile')]: {
      display: 'flex',
    },
  },
  descriptionItem: {
    padding: 0,
    flexDirection: 'column',
    alignItems: 'flex-start',
    [theme.breakpoints.up('mobile')]: {
      marginLeft: theme.spacing(7),
    },
  },
  descriptionTitle: {
    fontSize: 16,
    fontWeight: 700,
    [theme.breakpoints.up('mobile')]: {
      fontSize: 24,
    },
  },
  descriptionText: {
    fontSize: 16,
    margin: [theme.spacing(4), 0],
    lineHeight: '24px',
    '& b': {
      color: theme.palette.colors.black,
    },
  },
  bold: {
    color: theme.palette.colors.black,
  },
}));



// WEBPACK FOOTER //
// ./src/components/AboutUs/useStyles.js